import { render, staticRenderFns } from "./NoDataPrizeRequestHistory.vue?vue&type=template&id=1bdbdb28&scoped=true&"
import script from "./NoDataPrizeRequestHistory.vue?vue&type=script&lang=js&"
export * from "./NoDataPrizeRequestHistory.vue?vue&type=script&lang=js&"
import style0 from "./NoDataPrizeRequestHistory.vue?vue&type=style&index=0&id=1bdbdb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbdb28",
  null
  
)

export default component.exports